// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div.page-not-found[data-v-b9896a94]{margin-top:20px}h1[data-v-b9896a94],h2[data-v-b9896a94]{font-family:Roboto,sans-serif;text-align:center;font-weight:300!important}h1[data-v-b9896a94]{font-size:100px}", ""]);
// Exports
module.exports = exports;
